import {PropsWithChildren} from 'react'
import {Gradient} from 'slices/ProductOverview/components/separators'
import {SideEdges, Separators} from './Cells'

export const AffiliatesBannerGrid = ({
  children,
  animationClass,
  gridClass,
  length,
}: PropsWithChildren<{animationClass: string; gridClass: string; length: number}>) => {
  return (
    <div
      className={`relative grid w-max grid-rows-[40px_56px_78px] ${animationClass} md:grid-rows-[48px_64px_80px] xl:w-full ${gridClass}`}
    >
      <SideEdges side="left" />
      <SideEdges side="right" />
      <Separators length={length} />
      <Gradient color="247, 247, 247" gradientStart={0} height={24} location="top" />
      <Gradient color="247, 247, 247" gradientStart={0} height={24} location="bottom" />
      {children}
    </div>
  )
}
